import { useEffect } from "react";
import { CheckCircle } from "lucide-react";

interface RefundNotificationBannerProps {
  refundAmount: number;
  generationId: string;
  onViewed?: () => void;
}

/**
 * Reusable refund notification banner
 * Shows for 5 seconds then auto-acknowledges
 */
export function RefundNotificationBanner({
  refundAmount,
  generationId,
  onViewed,
}: RefundNotificationBannerProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      sessionStorage.setItem(`refund_ack_${generationId}`, "true");
      onViewed?.();
    }, 5000);
    return () => clearTimeout(timer);
  }, [generationId, onViewed]);

  return (
    <div className="mb-6 p-4 rounded-xl bg-green-500/10 border border-green-500/30 animate-in fade-in slide-in-from-top-2 duration-500">
      <div className="flex items-start gap-3">
        <CheckCircle className="size-5 text-green-400 flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-green-300 mb-1">
            Credits Refunded
          </p>
          <p className="text-xs text-green-200/80">
            {refundAmount
              ? `${refundAmount} credits returned to your account`
              : "Your credits have been returned"}
          </p>
        </div>
      </div>
    </div>
  );
}
